import { randomUUID } from 'crypto';
import type { IncomingHttpHeaders } from 'http';

import { EventbriteHeader } from '@eventbrite/webapp-constants';

/**
 * Reads a single header value from Node request `headers`, handling array values and whitespace.
 */
export function getHeaderValue(headers: IncomingHttpHeaders, name: string): string | undefined {
  const raw = headers[name];
  const value = Array.isArray(raw) ? raw[0] : raw;
  const trimmed = value?.trim();
  return trimmed || undefined;
}

/**
 * Reads Eventbrite Lambda-authorizer headers from Node request `headers`.
 * Shared by Next.js API routes and `getServerSideProps` (same header names).
 */
export function getSoaTokenFromHeaders(headers: IncomingHttpHeaders): string | undefined {
  return getHeaderValue(headers, EventbriteHeader.EB_SOA_TOKEN);
}

export function getUserIdFromHeaders(headers: IncomingHttpHeaders): string | undefined {
  return getHeaderValue(headers, EventbriteHeader.EB_USER_ID);
}

export function getSessionIdFromHeaders(headers: IncomingHttpHeaders): string | undefined {
  return getHeaderValue(headers, EventbriteHeader.EB_SESSION_ID);
}

export function getGuestIdFromHeaders(headers: IncomingHttpHeaders): string | undefined {
  return getHeaderValue(headers, EventbriteHeader.EB_GUEST_ID);
}

export function getCorrelationIdFromHeaders(
  headers: IncomingHttpHeaders,
  fallback: () => string = () => randomUUID(),
): string {
  return getHeaderValue(headers, EventbriteHeader.EB_CORRELATION_ID) ?? fallback();
}
